<template>
  <div class="feedback-message" :class="type">
    <span class="feedback-icon"><CheckIcon v-if="type === 'success'" /><WarningIcon v-else /></span>
    <div class="feedback-body">
      <slot>{{ message }}</slot>
    </div>
  </div>
</template>

<script>
import CheckIcon from '@/assets/icons/check.vue'
import WarningIcon from '@/assets/icons/warning.vue'

export default {
  components: { CheckIcon, WarningIcon },
  props: {
    type: {
      type: String,
      required: true,
      validator: v => ['success', 'warning', 'error'].includes(v)
    },
    message: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.feedback-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 16px;
  border-radius: var(--radius);
  font-size: var(--font-sm);
  line-height: 20px;
  text-align: left;
}

.feedback-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  /* Matches line-height above, so the icon centers on the first line. */
  height: 20px;
}

.feedback-icon svg {
  width: 16px;
  height: 16px;
}

.success {
  background-color: color-mix(in srgb, var(--color-admin-success) 12%, white);
  color: var(--color-admin-success);
  border-left: 3px solid var(--color-admin-success);
}

.warning {
  background-color: color-mix(in srgb, var(--color-admin-warning) 10%, white);
  color: var(--color-admin-warning);
  border-left: 3px solid var(--color-admin-warning);
}

.error {
  background-color: color-mix(in srgb, var(--color-admin-error) 10%, white);
  color: var(--color-admin-error);
  border-left: 3px solid var(--color-admin-error);
}
</style>
